import {Component, inject, OnInit} from '@angular/core';
import {LoadingCardContentComponent} from "../../../shared/loading-card-content/loading-card-content.component";
import {MatButton} from "@angular/material/button";
import {HasPermissionDirective} from "../../../directives/permissions/has-permission";
import {MatTooltip} from "@angular/material/tooltip";
import {AgGridAngular} from "ag-grid-angular";
import {UserHasCausableAdminAccessDirective} from "../../../directives/permissions/user-has-causable-admin-access.directive";
import {MatIcon} from "@angular/material/icon";
import {ColComponent, ContainerComponent, ListGroupDirective, ListGroupItemDirective, RowComponent} from "@coreui/angular";
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from "@angular/material/card";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {FormsModule} from "@angular/forms";
import {ChooseYourGameComponent} from "../../../components/choose-your-game/choose-your-game.component";
import {HasCrossGamePermissionDirective} from "../../../directives/permissions/has-cross-game-permission";
import {IGameQueryResult} from "../../../interfaces/IGameQueryResult";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {RouterLink} from "@angular/router";
import {BroadcastNotificationsTableComponent} from "../../../components/broadcast-notifications-table/broadcast-notifications-table.component";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {PermissionTypes} from "../../../enum/PermissionTypes";
import {BroadcastNotificationService} from "../../../services/broadcast-notification.service";
import {ErrorHandlingService} from "../../../services/error-handling.service";
import {IBroadcastNotification} from "../../../interfaces/notifications/IBroadcastNotification";

@Component({
  selector: 'app-cross-game-manage-notifications',
  standalone: true,
  imports: [
    LoadingCardContentComponent,
    MatButton,
    MatIcon,
    HasPermissionDirective,
    MatTooltip,
    AgGridAngular,
    UserHasCausableAdminAccessDirective,
    ColComponent,
    MatCard,
    MatCardContent,
    MatFormField,
    MatLabel,
    MatOption,
    MatSelect,
    RowComponent,
    FormsModule,
    ContainerComponent,
    ChooseYourGameComponent,
    ListGroupDirective,
    ListGroupItemDirective,
    MatCardTitle,
    MatCardHeader,
    HasCrossGamePermissionDirective,
    MatProgressSpinner,
    RouterLink,
    BroadcastNotificationsTableComponent
  ],
  templateUrl: './cross-game-manage-notifications.component.html',
  styleUrls: ['./cross-game-manage-notifications.component.css']
})
export class CrossGameManageNotificationsComponent implements OnInit {
  private broadcastNotificationService: BroadcastNotificationService = inject(BroadcastNotificationService);
  private errorHandlingService: ErrorHandlingService = inject(ErrorHandlingService);

  public broadcastNotifications: IBroadcastNotification[] = [];
  public uiState: UIStateEnum = UIStateEnum.ShowData;
  public uiStateEnumForTemplate = UIStateEnum;
  public permissionTypes = PermissionTypes;

  chosenGame: IGameQueryResult | null = null;
  enableGameSearch: boolean = true;

  ngOnInit() {
    this.enableGameSearch = true;
  }

  onGameChange(chosenGame: IGameQueryResult) {
    this.chosenGame = chosenGame;
    if (this.chosenGame?.Id) {
      this.loadNotificationsForGame(this.chosenGame.Id);
    }
  }

  private loadNotificationsForGame(gameId: string) {
    this.uiState = UIStateEnum.ShowLoading;
    this.broadcastNotificationService.getBroadcastNotificationsByGameId(gameId).subscribe({
      next: (notifications) => {
        this.broadcastNotifications = notifications;
        this.uiState = UIStateEnum.ShowData;
      },
      error: (err) => {
        this.uiState = UIStateEnum.ShowData;
        this.errorHandlingService.displayPageLevelErrorMessage(err);
      }
    });
  }
}
